module.exports = __webpack_public_path__ + "media/images/icons/avatar-outline-1f0742043c0386ac4593bb08d24cd9e0.svg";